<template>
  <div class="couponDetailApp" :style="'height:'+curHeight+'px;background:url('+require('../../assets/images/movies.webp')+') no-repeat bottom rgb(33,33,33);background-size:100%;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:12px"></div>
    <div class="headCoupon">
      <div class="user">
        <img :src="userData.avatar">
        <div class="name">Jersey <span>累计抢优惠 <font style="color:#E34D59;font-weight:bold;font-size:16px">{{orderTotal}}</font> 份</span></div>
      </div>
      <div class="coupon">
        <h2>{{arr.title}}</h2>
        <div class="noty">使用条件：满{{arr.use}}元，立减{{arr.price}}元</div>
        <div class="noty">{{arr.endTime}}到期</div>
        <div class="price"><font>￥<b>{{arr.rates}}</b></font><span>￥{{arr.price}}</span></div>

        <div class="pay" style="background:#ccc" v-if="arr.total - arr.useTotal <= 0">售罄</div>
        <div class="pay" @click="payment(arr.rates)" v-if="arr.total - arr.useTotal > 0">{{arr.rates > 0 ? '抢优惠' : '去领取'}}<em class="el-icon-arrow-right"></em></div>
      </div>
    </div>

    <div class="movies">
      <h2>特惠电影
        <a @click="$router.push('movies')">更多<em class="el-icon-arrow-right"></em></a>
      </h2>
      <ul class="lists">
        <li v-for="(item,i) in setMovies.list" v-if="i<6" @click="$router.push('moviesdetail?id='+item.movieId)">
          <el-image style="width: 100%;" :src="item.pic" fit="cover"></el-image>
          <div class="title">{{item.name}} </div>
          <div class="types">{{item.versionTypes}}</div>
          <div class="score">{{item.grade}}分</div>
          <div class="btn" :style="timestamp - item.publishDate <= 0 ? 'background: linear-gradient(90deg, #3F9DEC, #53C6F1);' : ''">{{timestamp - item.publishDate > 0 ? '购票' : '预售'}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        arr:[],
        positionFlag:false,
        bak:0,
        setMovies:[],
        code:'',
        timestamp:0,
        orderTotal:0
      };
    },
    created(){
      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/coupondetail?id='+id+(this.$route.query.bak == 1 ? '&bak=1' : ''));
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.bak = this.$route.query.bak == 1 ? 1 : 0;
      this.timestamp = Date.parse(new Date());
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getMovies();
      this.listCoupon()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      back:function(inx){
        if(inx == 1){
          this.$router.go(-1)
        }else{
          this.$router.push('movies')
        }
      },

      getQquey:function(){
        var that = this;
        var id = that.$route.query.id;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          });
          wx.ready(function() {
            //分享到朋友圈
            wx.onMenuShareTimeline({
                title:'电影优惠券', // 分享标题
                link:'http://user.4008005216.com/main/coupondetail?id='+id+(that.$route.query.bak == 1 ? '&bak=1' : ''), 
                imgUrl:that.setMovies.list[0].pic, // 分享图标
                success: function () {
                },
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title:'电影优惠券',
                desc:that.setMovies.list[0].name,
                link:'http://user.4008005216.com/main/coupondetail?id='+id+(that.$route.query.bak == 1 ? '&bak=1' : ''),
                imgUrl: that.setMovies.list[0].pic, 
                type: '',
                dataUrl: '', 
                success: function () {
                }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/couponDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.arr = data.data;
            that.fullscreenLoading = false;
          }
        })
      },

      listCoupon:function(){
        var that = this;
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          data:{
            user_id:that.userData.id
          },
          url:that.$host+'home/movies/coupon',
          dataType:'json',
          success:function(data){
            that.orderTotal = data.data.total
            that.fullscreenLoading = false;
          }
        })
      },

      getMovies:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/index',
          data:{
            types:0,
            cityCode:'',
            page:0,
            keywords:''
          },
          dataType:'json',
          success:function(data){
            that.setMovies = data.data;
            that.getQquey();
            that.fullscreenLoading = false;
          }
        })
      },

      payment:function(inx){
        var that = this;
        var id = this.$route.query.id;

        $.ajax({
          type:'post',
          url:that.$host+'home/movies/couponPayment',
          data:{
            coupon_id:id,
            user_id:that.userData.id,
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              if(inx <= 0){
                that.$alert((that.bak == 1 ? '领取成功，立即查看订单信息' : '支付成功，立即购票'), '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    that.listCoupon();
                    /*if(that.bak == 1){
                      that.$router.go(-1);
                    }else{
                      that.$router.push('movies')
                    }*/
                  }
                });
              }else{
                that.callpay(data.data);
              }
              
            }else{
              that.$alert(data.message, '提示', {
                confirmButtonText: '确定'
              });
            }
            that.fullscreenLoading = false;
          }
        })
      },
      jsApiCall:function(msg){
        var that = this;
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":'wxa89a20966e69c2a5',
              "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
              "nonceStr":msg.nonceStr, //随机串     
              "package":msg.package,     
              "signType":msg.signType,         //微信签名方式：     
              "paySign":msg.paySign 
            },
            function(res){
                if(res.err_msg == "get_brand_wcpay_request:ok"){
                  that.$alert((that.bak == 1 ? '抢优惠成功，快去看电影吧' : '抢优惠成功，快去看电影吧'), '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      if(that.bak == 1){
                        that.$router.go(-1);
                      }else{
                        that.$router.push('movies')
                      }
                    }
                  });
                }else{
                   //返回跳转到订单详情页面
                    alert('支付失败');return false
                }
            }
        );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .couponDetailApp{
    background:rgb(6,6,6);
  }
  .headCoupon{
    background: linear-gradient( 270deg, #FFFFFF 0%, #FEF2F3 100%);
    width:96%;
    margin:0 auto;
    border-radius: 6px;
    padding-bottom:10px
  }
  .headCoupon .user img{
    width:25px;
    height:25px;
    border-radius: 50%;
    margin:10px 8px 10px 10px;
    float:left;
  }
  .headCoupon .user .name{
    height:25px;
    float:left;
    line-height:25px;
    margin-top:10px;
    font-weight:bold
  }
  .headCoupon .user .name span{
    font-size:12px;
    margin-left:10px;
    font-weight:400
  }
  .headCoupon .user:after{
    display:block;
    clear:both;
    content:"";
    overflow:hidden;
    height:0;
  }
  .headCoupon .coupon{
    width:96%;
    margin:0 auto;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 1px #FEF2F3;
    padding-bottom:12px;
    position: relative;
  }
  .headCoupon .coupon h2{
    font-size:16px;
    color:#E34D59;
    width:94%;
    margin:0 auto;
    padding-top:12px;
  }
  .headCoupon .coupon .noty{
    width:94%;
    display:block;
    margin:0 auto;
    font-size:14px;
    color:#4B5B76;
    padding-top:8px;
  }
  .headCoupon .coupon .price{
    width:94%;
    display:block;
    margin:0 auto;
    font-size:16px;
    padding-top:8px;
  }
  .headCoupon .coupon .price font{
    color:#D76B37
  }
  .headCoupon .coupon .price span{
    font-size:13px;
    color:#999;
    text-decoration: line-through;
    margin-left:10px
  }
  .headCoupon .coupon .pay{
    background:#E34D59;
    width: 72px;
    height: 30px;
    position: absolute;
    color:#fff;
    text-align:Center;
    line-height: 30px;
    border-radius: 6px;
    bottom:12px;
    right:4%;
    font-size:15px;
  }
  .couponDetailApp .movies h2{
    font-size:18px;
    width:96%;
    margin:0 auto;
    color:#fff;
    padding:15px 0 10px 0;
  }
  .couponDetailApp .movies h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
  }
  .couponDetailApp .movies .lists{
    width:96%;
    margin:0 auto;
    display: grid;
    grid-template-columns: repeat(3, 31.5%);
    gap: 10px;
  }
  .couponDetailApp .movies .lists li{
    white-space:normal;
    text-align:center;
    color:#6f7580;
    font-size:15px;
    position: relative;
    font-size: 0;
    background: linear-gradient( 270deg, #FFFFFF 0%, #FEF2F3 100%);
    border-radius: 10px;
  }
  .couponDetailApp .movies .lists img{
    width: 100%;
    height: 130px;
    display: block;
    border-radius: 10px 10px 0 0;
  }
  .couponDetailApp .movies .lists .types{
    position: absolute;
    color: #fff;
    top: 5px;
    left: 5px;
    background: #000;
    border-radius: 10px;
    font-size: 12px;
    padding: 2px 5px;
    word-break: break-all;
  }
  .couponDetailApp .movies .lists .score{
    position: absolute;
    font-size: 12px;
    color:#F8A927;
    top: 105px;
    left: 5px;
    font-weight: bold;
  }
  .couponDetailApp .movies .lists .title{
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
    width: 96%;
    text-align: justify;
    margin: 5px auto 0 auto;
  }
  .couponDetailApp .movies .lists .btn{
    font-size: 15px;
    background: linear-gradient(90deg,#fe506a,#fe5ca3);
    color: #fff;
    width: 50px;
    border-radius: 30px;
    margin: 7px auto;
    display: block;
    height: 30px;
    line-height: 30px;
  }
</style>